import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

/** GET /groups/by-office 한 행 */
export type GroupByOfficeRow = {
  group_id: string;
  group_name: string;
  office_id: string;
  /** 마스터/HN 등만 채워짐 — 수간호사 등은 빈 배열일 수 있음 */
  hn_id: string[];
};

export type UseGroupsByOfficeQueryOptions = {
  enabled: boolean;
  /** GET /groups/by-office?office_id= … 필수 */
  officeId: string | null | undefined;
};

/** GET /groups/by-office — 사무실 소속 병동 목록 (수간호사 포함 권한 확대) */
export function useGroupsByOfficeQuery({
  enabled,
  officeId,
}: UseGroupsByOfficeQueryOptions) {
  const oid = (officeId ?? "").trim();

  return useQuery({
    queryKey: QUERY_KEYS.groups.byOffice(oid),
    queryFn: async () => {
      return await httpClient.get<GroupByOfficeRow[]>("/groups/by-office", {
        params: { office_id: oid },
      });
    },
    enabled: enabled && oid.length > 0,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
